import React from 'react'
import { getLocalizedVal } from '~/tools/localization/helpers';
import { isSite } from '~/tools/isSite'

class NextVideoTimer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      timer: props.timer
    }

    this.changeTimer = this.changeTimer.bind(this)
  }

  componentDidMount() {
    this.interval = setInterval(this.changeTimer, 1000)
  }

  changeTimer(){
    this.setState({ timer: this.state.timer - 1 })
    if (this.state.timer <= 0) {
      clearInterval(this.interval)
      this.props.action && this.props.action()
    }
  }

  render() {
    let background = {}
    if(this.props.backgroundUrl) {
      background = {
        background: `url(${this.props.backgroundUrl}) no-repeat`,
        backgroundSize: 'cover',
      }
    } else {
      background = {
        backgroundSize: 'cover',
      }
    }
    const label = isSite('bingeflix') ? getLocalizedVal(window.settings,'genericMessages', 'programLabel') : getLocalizedVal(window.settings,'genericMessages', 'episodeLabel')
    const willStartInLabel = getLocalizedVal(window.settings,'genericMessages', 'willStartInLabel') || 'will start in';
    const videoLabel = getLocalizedVal(window.settings,'genericMessages', 'videoLabel') || 'Video';
    return (
      <div className="timer-prompt" style={ background }>
        <div className="next-episode-timer">
          {getLocalizedVal(window.settings,'genericMessages', 'nextLabel')} {this.props.isPlaylistItem ? videoLabel : label } {this.props.nextVideoTitle} {willStartInLabel} {this.state.timer}
        </div>
      </div>
    )
  }
}

export default NextVideoTimer